import { Component } from '@angular/core';
import { DocumentModalService } from '@app/features/main/views/organization-documents/modals/document-modal.service';
import { WorkModalService } from '@app/features/main/views/works/works-inventory/modals/work-modal.service';
import {
  WorksSidebarComponent
} from '@app/features/main/views/works/works-inventory/works-sidebar/works-sidebar.component';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';

@Component({
    selector: 'project-works-sidebar',
    templateUrl: './project-works-sidebar.component.html',
    styleUrls: ['./project-works-sidebar.component.scss'],
    providers: [WorkModalService, DocumentModalService, FormStateService],
    standalone: false
})
export class ProjectWorksSidebarComponent extends WorksSidebarComponent {
  public formId = 'project_work_sidebar';
}
